import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { any, bool, func, node, object, oneOf, string } from 'prop-types';
import { PLACEMENT } from "./constants";
export var tooltipPropTypes = {
  children: node.isRequired,
  cursor: string,
  content: string.isRequired,
  defaultIsOpen: bool,
  disabled: bool,
  hasArrow: bool,
  id: string,
  isOpen: bool,
  modifiers: object,
  onClose: func,
  onOpen: func,
  placement: oneOf(Object.keys(PLACEMENT)),
  positionFixed: bool,
  subtitle: any,
  title: any,
  usePortal: bool
};